export default "__VITE_ASSET__knSIe$s3__"